import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

const Loader = ({ 
    height = "50", 
    width = "50", 
    color = "#007bff", 
    size = "medium",
    text = "Loading...",
    showText = true,
    className = ""
}) => {
    // Size presets
    const sizeConfig = {
        small: { height: "20", width: "20" },
        medium: { height: "50", width: "50" },
        large: { height: "80", width: "80" }
    };

    const config = sizeConfig[size] || { height, width };

    return (
        <div className={`loader-container ${className}`} style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            padding: '20px'
        }}>
            <ThreeDots
                height={config.height}
                width={config.width}
                radius="9"
                color={color}
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
            />
            {showText && (
                <p style={{ 
                    marginTop: '10px', 
                    color: color, 
                    fontSize: '14px',
                    fontWeight: '500'
                }}>
                    {text}
                </p>
            )}
        </div>
    );
};

export default Loader;
